var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrismIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 188,
    viewBox: "0 0 268 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.952 66L126 78H140L132.952 66Z",
    fill: "#363F78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.457 0L132.976 67.4219L139.2 77.544L267.743 8.58749L262.457 0Z",
    fill: "#424B8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.457 0L5.46814 2.15529L132.976 67.4219L262.457 0Z",
    fill: "#38417A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46722 2.15527L0.257202 10.7559L126.835 77.544L132.975 67.4218L5.46722 2.15527Z",
    fill: "#293161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.257202 10.7559L127.764 187.62L126.835 77.5435L0.257202 10.7559Z",
    fill: "#262B52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.836 77.5439L127.765 187.621L138.27 187.621L139.2 77.5439H126.836Z",
    fill: "#293161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.743 8.58789L139.2 77.5439L138.27 187.621L267.743 8.58789Z",
    fill: "#2A315C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrismIcon);
export default __webpack_public_path__ + "static/media/PrismIcon.d552a1e6da22f19e15851c67d8b3e000.svg";
export { ForwardRef as ReactComponent };